import { useContext } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { UserContext } from '../../../context';
import {
  PortalCard,
  AvidSection,
  PartOfOurStorySection,
  ReferralProgramSection
} from './components';
import { HeroSection, HomeownerPortalWrapper, BuildsDropdown } from '../components';
import { homeownerPortalTheme } from '../styles/homeowner-portal-theme';
import { HOMEOWNER_PORTAL_ROUTES } from '../routes';
import landingImage from '../../../assets/homeowner-portal/homeowner_portal_hero.webp';

export const HomeownerPortalLanding = () => {
  const { user } = useContext(UserContext);
  const firstName = user?.fullName?.split(' ')[0] || user?.userName || 'Purchaser';

  return (
    <HomeownerPortalWrapper>
      <Box sx={{ flex: 1 }}>
        <HeroSection
          image={landingImage}
          title="Homeowner Portal"
          subtitle="All the information you need for your new home."
          backgroundPosition="0 50%"
        />
        <Box sx={{ mb: 4, mt: 4, mx: 4 }}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item xs={12} md={8}>
              <Typography variant="h3">
                Hi {firstName}, Welcome to your Homeowner Portal!
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              sx={{
                display: 'flex',
                justifyContent: { xs: 'flex-start', md: 'flex-end' },
                mt: { xs: 2, md: 0 }
              }}
            >
              <BuildsDropdown sx={{ minWidth: { xs: '100%', md: 280 } }} />
            </Grid>
          </Grid>
        </Box>
        <Box
          sx={{
            backgroundColor: homeownerPortalTheme.palette.backgroundBlue.main,
            py: { xs: 2, md: 4 },
            px: { xs: 2, md: 4 }
          }}
        >
          <Grid container spacing={3}>
            {portalCards.map((card, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <PortalCard title={card.title} linkText={card.linkText} to={card.to} />
              </Grid>
            ))}
          </Grid>
        </Box>
        <AvidSection />
        <PartOfOurStorySection />
        <ReferralProgramSection />
      </Box>
    </HomeownerPortalWrapper>
  );
};

const portalCards = [
  {
    title: 'My Home is Currently Under Construction',
    linkText: 'Phases of Construction',
    to: HOMEOWNER_PORTAL_ROUTES.CONSTRUCTION_PHASES
  },
  {
    title: 'Learn More About My Community',
    linkText: 'Community Info',
    to: HOMEOWNER_PORTAL_ROUTES.LEARN_MORE_COMMUNITY
  },
  {
    title: 'Learn More About My Home',
    linkText: 'Homeowner Documents',
    to: HOMEOWNER_PORTAL_ROUTES.ABOUT_MY_HOME
  },
  {
    title: 'File a Warranty Claim',
    linkText: 'Warranty Portal',
    to: HOMEOWNER_PORTAL_ROUTES.WARRANTY_PORTAL
  }
];
